var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c("el-button", {
    attrs: {
      type: "success"
    },
    on: {
      click: function click($event) {
        return _vm.openConfig();
      }
    }
  }, [_vm._v(" 同步cp配置 ")])], 1), _c("div", [_c("el-table", {
    attrs: {
      data: _vm.tableData,
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      type: "index",
      width: "50"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "开服时间",
      prop: "openTimeStr",
      width: "155"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "实际开服时间",
      prop: "realOpenTimeStr",
      width: "155"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("div", {
          staticStyle: {
            color: "#409EFF",
            cursor: "pointer"
          },
          on: {
            click: function click($event) {
              return _vm.realOpentimeModifyMsg(scope.row);
            }
          }
        }, [scope.row.realOpenTimeStr == "1970-01-01 00:00:00" ? _c("span", [_vm._v(_vm._s(scope.row.openTimeStr))]) : _c("span", [_vm._v(_vm._s(scope.row.realOpenTimeStr))])])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "大区名称",
      prop: "area",
      width: "150"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "渠道id",
      prop: "channelId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "服务器ID",
      prop: "serverId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "服务器名称",
      prop: "serverName",
      width: "130"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "是否推荐"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.isMerge == 1 ? "是" : "否") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "合服后的主服务器ID",
      width: "160",
      prop: "mergeMasterId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "合服后的主服务器名称",
      prop: "mergeName",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "合服次数",
      prop: "mergeTimes"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "标签ID",
      prop: "stateCode"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "标签名称"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var row = _ref.row;
        return [_vm._v(" " + _vm._s(_vm.getStateDesc(row.stateCode)) + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            type: "primary",
            plain: ""
          },
          on: {
            click: function click($event) {
              return _vm.modifyMsg(scope.row);
            }
          }
        }, [_vm._v("修改")])];
      }
    }])
  })], 1)], 1), _c("div", [_c("el-dialog", {
    attrs: {
      title: "提示",
      visible: _vm.centerDialogVisible,
      width: "500px",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.centerDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    staticStyle: {
      "margin-left": "10%"
    },
    attrs: {
      "label-width": "100px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器ID："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.server_id,
      callback: function callback($$v) {
        _vm.server_id = $$v;
      },
      expression: "server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务器名称："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.server_name,
      callback: function callback($$v) {
        _vm.server_name = $$v;
      },
      expression: "server_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "开服时间："
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: true,
      type: "datetime",
      placeholder: "选择日期时间",
      "picker-options": _vm.option,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      change: function change($event) {
        return _vm.modifyData(_vm.value1);
      }
    },
    model: {
      value: _vm.value1,
      callback: function callback($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务器状态："
    }
  }, [_c("el-select", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      placeholder: "请选择"
    },
    model: {
      value: _vm.sel_server,
      callback: function callback($$v) {
        _vm.sel_server = $$v;
      },
      expression: "sel_server"
    }
  }, _vm._l(_vm.options, function (item) {
    return _c("el-option", {
      key: item.value,
      attrs: {
        label: item.label,
        value: item.value
      }
    });
  }), 1)], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.preserBtn();
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1), _c("div", [_c("el-dialog", {
    attrs: {
      title: "提示",
      visible: _vm.realOpenDialogVisible,
      width: "500px",
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.realOpenDialogVisible = $event;
      }
    }
  }, [_c("el-form", {
    staticStyle: {
      "margin-left": "10%"
    },
    attrs: {
      "label-width": "140px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器ID："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.server_id,
      callback: function callback($$v) {
        _vm.server_id = $$v;
      },
      expression: "server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "服务器名称："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.server_name,
      callback: function callback($$v) {
        _vm.server_name = $$v;
      },
      expression: "server_name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "开服时间："
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      disabled: true,
      type: "datetime",
      placeholder: "选择日期时间",
      "picker-options": _vm.option,
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    model: {
      value: _vm.value1,
      callback: function callback($$v) {
        _vm.value1 = $$v;
      },
      expression: "value1"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "实际开服时间："
    }
  }, [_c("el-date-picker", {
    staticStyle: {
      width: "230px"
    },
    attrs: {
      type: "datetime",
      placeholder: "选择日期时间",
      "value-format": "yyyy-MM-dd HH:mm:ss"
    },
    on: {
      change: function change($event) {
        return _vm.modifyData();
      }
    },
    model: {
      value: _vm.real_open_time_str,
      callback: function callback($$v) {
        _vm.real_open_time_str = $$v;
      },
      expression: "real_open_time_str"
    }
  }), _c("br"), _c("span", {
    staticStyle: {
      color: "red"
    }
  }, [_vm._v("人工填写服务器真实开服时间，仅后台展示和数据统计用，不影响游戏内开服状态")])], 1)], 1), _c("span", {
    staticClass: "dialog-footer",
    attrs: {
      slot: "footer"
    },
    slot: "footer"
  }, [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.saveRealOpenTimeBtn();
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };